import { useMutation } from "@tanstack/react-query";
import { signInWithEmailAndPassword } from "firebase/auth";
import { storeCredentials } from "../../../apiClient";
import { LoginInputDto, LoginOutputDto } from "../../../models/organization/dto/onboarding.dto";
import { auth } from "../firebase";

export const useSignIn = (onSuccess: (data: LoginOutputDto) => void) => {
    return useMutation({
        mutationKey: ['signIn'],
        mutationFn: async (input: LoginInputDto) => {
            const result = await signInWithEmailAndPassword(auth, input.email, input.password);
            const idToken = await result.user.getIdToken();
            return { accessToken: idToken, refreshToken: result.user.refreshToken };
        },
        onSuccess: (data: LoginOutputDto) => {
            storeCredentials(data.accessToken, data.refreshToken)
            onSuccess(data);
        },
    });
};